export const ROLES = {
  MICRO: 'MICRO',
  PREMIUM: 'PREMIUM',
};

export const MODAL_TYPES = {
  BLACKLIST: 'BLCKLIST',
  PREMIUM: 'PREMIUM',
  DECLINED: 'DECLINED',
  REAPPLY: 'REAPPLY',
};

export const ADVERTISER_SECTIONS = {
  brief: 'brief',
  shortlist: 'shortlist',
  profiles: 'profiles',
  drafts: 'drafts',
  published: 'published',
  completed: 'completed',
};

export const MEDIA_TYPES = {
  POSTS: 'POSTS',
  STORIES: 'STORIES',
  REELS: 'REELS',
  POST: 'POST',
  STORY: 'STORY',
  REEL: 'REEL',
  VIDEO: 'VIDEO',
  VIDEOS: 'VIDEOS',
};

export const SOCIAL_MEDIA_PLATFORMS = {
  INSTAGRAM: 'INSTAGRAM',
  TIKTOK: 'TIKTOK',
  UGC: 'UGC',
};

export const CAMPAIGN_MEDIA_TYPES = {
  INSTAGRAM_POST: 'INSTAGRAM_POST',
  INSTAGRAM_STORY: 'INSTAGRAM_STORY',
  INSTAGRAM_REEL: 'INSTAGRAM_REEL',
  TIKTOK_VIDEO: 'TIKTOK_VIDEO',
  UGC_POST: 'UGC_POST',
  UGC_VIDEO: 'UGC_VIDEO',
  TIKTOK_UGC_PHOTO: 'TIKTOK_UGC_PHOTO',
};

export const NON_POSTABLE_CAMPAIGN_MEDIA_TYPES = [
  CAMPAIGN_MEDIA_TYPES.UGC_POST,
  CAMPAIGN_MEDIA_TYPES.UGC_VIDEO,
  CAMPAIGN_MEDIA_TYPES.TIKTOK_UGC_PHOTO,
];

export const NON_POSTABLE_MEDIA_LISTS = [
  'ugcPosts',
  'ugcVideos',
  'tiktokUgcPhotos',
];

export const isNonPostableContent = (mediaTypeOrList) =>
  NON_POSTABLE_CAMPAIGN_MEDIA_TYPES.includes(mediaTypeOrList) ||
  NON_POSTABLE_MEDIA_LISTS.includes(mediaTypeOrList);

export const CAMPAIGN_ROUTE_REDIRECTION_TYPES = {
  CAMPAIGN_BRIEF_SUBMITTED: 'CAMPAIGN_BRIEF_SUBMITTED',
  CAMPAIGN_SHORTLIST_SUBMITTED: 'CAMPAIGN_SHORTLIST_SUBMITTED',
  CAMPAIGN_PARTICIPANT_DECLINED_INVITATION:
    'CAMPAIGN_PARTICIPANT_DECLINED_INVITATION',
  CAMPAIGN_ALL_PROFILES_HAVE_SENT_DETAILS:
    'CAMPAIGN_ALL_PROFILES_HAVE_SENT_DETAILS',
  CAMPAIGN_ITEMS_SHIPPED: 'CAMPAIGN_ITEMS_SHIPPED',
  CAMPAIGN_PARTICIPANT_LATE_TO_SUBMIT_DRAFT:
    'CAMPAIGN_PARTICIPANT_LATE_TO_SUBMIT_DRAFT',
  CAMPAIGN_DRAFT_SUBMITTED: 'CAMPAIGN_DRAFT_SUBMITTED',
  CAMPAIGN_VERIFY_PUBLISHED_CONTENT: 'CAMPAIGN_VERIFY_PUBLISHED_CONTENT',
  CAMPAIGN_PUBLISHED_CONTENT_HAS_CHANGED:
    'CAMPAIGN_PUBLISHED_CONTENT_HAS_CHANGED',
  CAMPAIGN_COMPLETED: 'CAMPAIGN_COMPLETED',
};

export const SOCIAL_MEDIA_PLATFORMS_RESET_FIELDS = {
  [SOCIAL_MEDIA_PLATFORMS.INSTAGRAM]: [
    'includeVideos',
    'includeUGCPosts',
    'includeUGCVideos',
    'includeTikTokUGCPhotos',
  ],
  [SOCIAL_MEDIA_PLATFORMS.TIKTOK]: [
    'includePosts',
    'includeStories',
    'includeReels',
    'includeUGCPosts',
    'includeUGCVideos',
  ],
  [SOCIAL_MEDIA_PLATFORMS.UGC]: [
    'includePosts',
    'includeStories',
    'includeReels',
    'includeVideos',
    'includeTikTokUGCPhotos',
  ],
};
